import { useState } from "react";
import Link from "@/components/ui/RouterLink";
import { X, ArrowRight } from "lucide-react";
import { announcement } from "@/config/brand";

export function AnnouncementBar() {
  const [dismissed, setDismissed] = useState(false);

  if (!announcement.enabled || dismissed) return null;

  return (
    <div className="relative bg-navy-secondary px-4 py-2.5 text-center text-xs text-text-secondary sm:text-sm">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-3">
        <span>{announcement.message}</span>
        <Link
          href={announcement.ctaHref}
          className="focus-ring inline-flex items-center gap-1 font-medium text-cyan hover:underline"
        >
          {announcement.ctaLabel} <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
      <button
        aria-label="Dismiss announcement"
        onClick={() => setDismissed(true)}
        className="focus-ring absolute right-4 top-1/2 -translate-y-1/2 text-text-muted hover:text-text-primary"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
